export function cleanNormalizedUndefinedEntities(entitiesGroup = {}) {
  return Object.entries(entitiesGroup).reduce(
    (cleanEntitiesGroup, [entityName, entities]) => {
      const { undefined: ignored, ...cleanEntities } = entities;

      return {
        ...cleanEntitiesGroup,
        [entityName]: cleanEntities
      };
    },
    {}
  );
}

export default cleanNormalizedUndefinedEntities;
